__turbopack_context__.v({
  "entry": "WPath-module__QObpTW__entry",
  "entryActive": "WPath-module__QObpTW__entryActive",
  "iconHome": "WPath-module__QObpTW__iconHome",
  "item": "WPath-module__QObpTW__item",
  "link": "WPath-module__QObpTW__link",
  "list": "WPath-module__QObpTW__list",
  "root": "WPath-module__QObpTW__root",
  "separator": "WPath-module__QObpTW__separator",
  "text": "WPath-module__QObpTW__text",
});
